var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonlaLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 6.58993,
    fill: "#E1F4F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6663 10.8914V14.3335C21.6663 14.8002 21.6663 15.0335 21.7572 15.2118C21.8371 15.3686 21.9645 15.4961 22.1213 15.576C22.2996 15.6668 22.533 15.6668 22.9997 15.6668H26.4418M23.333 19.8334H16.6663M23.333 23.1667H16.6663M18.333 16.5001H16.6663M21.6663 10.6667H17.333C15.9329 10.6667 15.2328 10.6667 14.698 10.9392C14.2276 11.1789 13.8452 11.5614 13.6055 12.0318C13.333 12.5666 13.333 13.2666 13.333 14.6667V23.3334C13.333 24.7335 13.333 25.4336 13.6055 25.9684C13.8452 26.4388 14.2276 26.8212 14.698 27.0609C15.2328 27.3334 15.9329 27.3334 17.333 27.3334H22.6663C24.0665 27.3334 24.7665 27.3334 25.3013 27.0609C25.7717 26.8212 26.1542 26.4388 26.3939 25.9684C26.6663 25.4336 26.6663 24.7335 26.6663 23.3334V15.6667L21.6663 10.6667Z",
    stroke: "#06A489",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonlaLinkIcon);
export default __webpack_public_path__ + "static/media/personlaLinkIcon.31bb8f32e59deb01183ee82bc8a82cd3.svg";
export { ForwardRef as ReactComponent };